import { https } from '../https';
import { IGetNavigationTreeDTO } from './navigation.dto';

export const baseUrl = '/v1/navigation';
export const navigationData = {
  getNavigationTree: async (customerId: number): Promise<IGetNavigationTreeDTO> => {
    const data = await https.get<IGetNavigationTreeDTO>(baseUrl, {
      headers: { 'Gtm-Customer-Id': customerId },
    });
    return data;
  },
};
